import React, { forwardRef } from "react";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";

const CustomButton = forwardRef((props, ref) => (
  <Button ref={ref} {...props} color="primary" variant="contained" disableElevation />
));

CustomButton.displayName = "FlatPrimaryButton";

export default withStyles((theme) => ({
  containedPrimary: {
    "& .MuiButton-label": {
      fontWeight: 300,
      fontSize: 24,
      [theme.breakpoints.between(1024, 1320)]: {
        fontSize: 20,
      },
    },
  },
}))(CustomButton);
